import { useEffect, useState } from "react"

export default function useFastSpring() {
    const [fastSpringData, setFastSpringData] = useState(undefined)
    const [fastSpringProducts, setFastSpringProducts] = useState(undefined)
    
    // FASTSPRING SBL
    useEffect(() => {
        if(
            typeof window === 'undefined' ||
            typeof document === 'undefined' ||
            document.getElementById('fsc-api')
        ) return
    
        const dataCallback = data => setFastSpringData(data)
        window.dataCallback = dataCallback
    
        const script = document.createElement('script')
        script.id = 'fsc-api'
        script.src = 'https://sbl.onfastspring.com/sbl/1.0.7/fastspring-builder.min.js'
        script.type = 'text/javascript'
        script.setAttribute('data-storefront', 'alesis.onfastspring.com/popup-alesis')
        script.setAttribute('data-data-callback', 'dataCallback')
        script.setAttribute('data-continuous', 'true')

        document.body.appendChild(script)
        return () => document.body.removeChild(script)
    }, [])
    
    useEffect(() => {
        if(!fastSpringData) return
        setFastSpringProducts(fastSpringData?.groups[0]?.items)
    }, [fastSpringData])

    // console.log(fastSpringData, fastSpringProducts)
    // console.log(fastSpringData)
    // console.log(fastSpringProducts)
    return { fastSpringData, fastSpringProducts }
}
